import React from 'react'
import { ThemeProvider } from 'styled-components'
import { theme, GlobalStyles, helpers } from '../theme'
import { usePageContext } from './PageContext'

export default ({ children }) => {
  const { pageContext } = usePageContext() || { pageContext: null }
  
  return (
    <ThemeProvider theme={{ ...theme, ...helpers }}>
      <GlobalStyles pageContext={pageContext} />
      {children}
    </ThemeProvider>
  )
}
